import Alpine from 'alpinejs';

export default function registerCalendarSettingsResourcesStore() {
  const existing = Alpine.store('calendarSettingsResourcesStore');
  if (existing) return existing;

  const baseStore = Alpine.store('calendarSettingsStore');
  if (!baseStore) return null;

  const store = {};
  Object.defineProperties(store, Object.getOwnPropertyDescriptors(baseStore));

  const resourcesExtensions = {
    showCreateExtraModal: false,
    showEditExtraModal: false,
    accommodationListingsExpanded: true,
    tourListingsExpanded: true,
    packageListingsExpanded: true,
    accommodationItemsExpanded: false,
    tourItemsExpanded: false,
    generalExtrasExpanded: true,
    addonsExpanded: true,
    async init() {
      this.initializeSettingsContext();
      this.loadExtras();
      this.loadTaxFees();
      window.setTimeout(() => this.ensureModalBindings(), 0);
    },
    openCreateExtraModal() {
      if (typeof this.resetNewExtra === 'function') {
        this.resetNewExtra();
      }
      this.showCreateExtraModal = true;
      window.setTimeout(() => this.ensureModalBindings(), 0);
    },
  };

  Object.defineProperties(
    store,
    Object.getOwnPropertyDescriptors(resourcesExtensions),
  );

  return Alpine.store('calendarSettingsResourcesStore', store);
}
